/* global process */

// Top-level configuration for the App. Takes most variables from ENV files,
// sourced via dotenv

import * as R from 'ramda'

const testDefault = (actual, test) => (process.env.NODE_ENV === 'test' ? test : actual)

const IGNITION_API = testDefault(process.env.IGNITION_API, 'http://localhost')
const GOOGLE_RECAPTCHA_SITE_KEY = testDefault(
  process.env.GOOGLE_RECAPTCHA_SITE_KEY,
  '6LcJJ6EUAAAAABNEc45N5LwZyFK7bKpGys-KxAR8'
)
const GOOGLE_GEOCODE_API_KEY = testDefault(
  process.env.GOOGLE_GEOCODE_API_KEY,
  'AIzaSyCDWECPzRQlJQBNrH64SvV84zATv8ZNza0'
)
const GOOGLE_ANALYTICS_TRACKING_ID = testDefault(process.env.GOOGLE_ANALYTICS_TRACKING_ID, 'G-GFPT0Z6H70')

const DISABLE_AUTH = testDefault(process.env.DISABLE_AUTH, false)

const APPSIGNAL_KEY = testDefault(process.env.APPSIGNAL_KEY, 'fake')

const BUILD_NUMBER = testDefault(process.env.BUILD_NUMBER, '0.0.0')

const IS_DEVELOPMENT = process.env.NODE_ENV === 'development' ? true : false

const SCHEMA = testDefault(process.env.SCHEMA, 'defaultAUSchema.js')

const config = {
  IGNITION_API,
  GOOGLE_RECAPTCHA_SITE_KEY,
  GOOGLE_GEOCODE_API_KEY,
  GOOGLE_ANALYTICS_TRACKING_ID,
  DISABLE_AUTH,
  APPSIGNAL_KEY,
  BUILD_NUMBER,
  IS_DEVELOPMENT,
  SCHEMA
}

const checkForErrors = values => {
  R.ifElse(
    R.any(R.isNil),
    () => {
      throw Error(
        `App not configured correctly - missing environment variables.
        If running locally: Have you configured your .env?`
      )
    },
    R.identity
  )(values)
}

R.pipe(R.values, checkForErrors)(config)

export default config
